// SPEC-ALERT-ICON-SIMPLIFY-01 (D-308): icon_key → 単色シルエットの唯一の写像(1箇所のみ・二重定義禁止)+ 描画部品。
//   icon_key があり写像に存在 → シルエット(color_hex を currentColor に着色)。
//   icon_key が null / 未知 → 種別コードの既定アイコン(D-1010)→ それも無ければ icon_emoji フォールバック。
import React from 'react'
import {
  GiftIcon, RefreshCwIcon, TriangleAlertIcon, CircleQuestionMarkIcon, TrendingDownIcon,
  ScanTextIcon, ActivityIcon, PackageXIcon, CircleDotIcon,
} from './alertSilhouettes'

// 唯一の写像。migration の UPDATE と一致(gift / refresh-cw / triangle-alert / circle-question-mark / trending-down)。
// D-1010: scan-text / activity / package-x を追加(管理画面のアイコン選択にもそのまま出る)。
export const ALERT_ICON_MAP = {
  'gift': GiftIcon,
  'refresh-cw': RefreshCwIcon,
  'triangle-alert': TriangleAlertIcon,
  'circle-question-mark': CircleQuestionMarkIcon,
  'trending-down': TrendingDownIcon,
  'scan-text': ScanTextIcon,
  'activity': ActivityIcon,
  'package-x': PackageXIcon,
}

export const ALERT_ICON_KEYS = Object.keys(ALERT_ICON_MAP)

// D-1010 (ひろ 2026-10-08「変わってないアイコンもシンプルに合わせたい」):
//   D-308 の後に足された 3 種別は DB の icon_key が null のまま(絵文字 🔀 📈 📤 で出ていた)。
//   DB を書き換えずに線のアイコンで出すため、種別コード → icon_key の既定をここ 1 か所に持つ。
//   ★アイコンを差し替えるときはこの 1 行を変えるだけ。DB の icon_key が入っていればそちらが勝つ。
//   (DB 側を揃える SQL は supabase/acceptance/d1010_report_type_icons.sql、未適用)
export const DEFAULT_ICON_KEY_BY_TYPE_CODE = {
  ocr_model_disagreement: 'scan-text', // 🔀 OCR読取不一致
  meter_delta_anomaly: 'activity',     // 📈 メーター差分異常
  prize_out_anomaly: 'package-x',      // 📤 払出メーター異常
}

// 純関数: 描くべき icon_key。DB の icon_key(写像にあるもの)→ 種別コードの既定 → null(=絵文字)。
export function resolveAlertIconKey({ iconKey, typeCode }) {
  if (iconKey && ALERT_ICON_MAP[iconKey]) return iconKey
  const byCode = typeCode ? DEFAULT_ICON_KEY_BY_TYPE_CODE[typeCode] : null
  return byCode && ALERT_ICON_MAP[byCode] ? byCode : null
}

// 純関数: icon_key に対応する SVG コンポーネント(無ければ null)。
export function silhouetteFor(iconKey) {
  return (iconKey && ALERT_ICON_MAP[iconKey]) || null
}

// 報告種別アイコンの唯一の描画部品。全レンダリング箇所はこれを通す(icon_emoji 直描画を残さない)。
//   D-1013: 絵文字は DB に入っている(空でない)ときだけ描く。'' は空白の span になっていたので、
//   アイコンも絵文字も無いときは 📌 ではなく Lucide の circle-dot(中立の印、種別の色)。
export default function AlertTypeIcon({ iconKey, typeCode, iconEmoji, size = 20, color, className }) {
  const Silhouette = silhouetteFor(resolveAlertIconKey({ iconKey, typeCode }))
  if (Silhouette) return <Silhouette size={size} color={color} className={className} />
  const emoji = typeof iconEmoji === 'string' ? iconEmoji.trim() : ''
  if (emoji) return <span className={className} aria-hidden="true">{emoji}</span>
  return <CircleDotIcon size={size} color={color} className={className} />
}
